import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import GettingStartedImg from 'assets/images/path-footer.svg';
import { M3Button } from 'components/M3/M3Buttons';

import { GettingStartedLogo } from './GetStartedToday.styles';

type GetStartedTodayProps = {};

const GetStartedToday: React.FC<GetStartedTodayProps> = () => {
  return (
    <Box
      id='getting-started'
      display='flex'
      justifyContent={{
        xs: 'center',
        md: 'flex-start',
      }}
      alignItems='center'
      flexDirection={{
        xs: 'column-reverse',
        md: 'row',
      }}
    >
      <Box
        display='flex'
        flexDirection='column'
        alignItems={{
          xs: 'center',
          md: 'flex-start',
        }}
        gap={3}
      >
        <Typography
          fontSize={{
            xs: '20px',
            sm: '36px',
          }}
          fontWeight={500}
          lineHeight={{
            xs: '28px',
            md: '44px',
          }}
          minWidth={{
            xs: 'auto',
            sm: '494px',
          }}
          textAlign={{
            xs: 'center',
            md: 'left',
          }}
          mt={{
            xs: 5,
            sm: 0,
          }}
        >
          Ready to take control of your career?
        </Typography>
        <Typography
          fontSize='16px'
          fontWeight={400}
          lineHeight='24px'
          gutterBottom
          textAlign={{
            xs: 'center',
            md: 'left',
          }}
        >
          Apply to be part of the Go2 Career Path program today:
        </Typography>
        <M3Button
          sx={{
            '&.MuiButton-containedPrimary': {
              color: '#fff !important',
              background: '#006495 !important',
            },
            minWidth: '200px',
            fontSize: '21px',
            fontWeight: 600,
            lineHeight: '30px',
            p: 4,
          }}
          variant='contained'
          onClick={() => {
            window.location.href = 'https://forms.gle/CPiR7ho1rBqT1vAa6';
          }}
        >
          Apply to join Beta
        </M3Button>
      </Box>
      <GettingStartedLogo alt='Getting started' src={GettingStartedImg} />
    </Box>
  );
};

export default GetStartedToday;
